// Utility functions for blog post management

export const exportBlogPosts = (posts) => {
  const dataStr = JSON.stringify({ posts }, null, 2);
  const dataBlob = new Blob([dataStr], { type: 'application/json' });
  
  const link = document.createElement('a');
  link.href = URL.createObjectURL(dataBlob);
  link.download = 'blogPosts.json';
  link.click();
  
  URL.revokeObjectURL(link.href);
};

export const generateUniqueId = (posts) => {
  const maxId = Math.max(...posts.map(post => parseInt(post.id)), 0);
  return (maxId + 1).toString();
};

export const validateBlogPost = (post) => {
  const errors = [];
  
  if (!post.title || post.title.trim().length === 0) {
    errors.push('Title is required');
  }
  
  if (!post.date) {
    errors.push('Date is required');
  }
  
  if (!post.text || post.text.trim().length === 0) {
    errors.push('Text content is required');
  }
  
  if (!post.linkUrl || post.linkUrl.trim().length === 0) {
    errors.push('Link URL is required');
  }
  
  // Basic URL validation
  try {
    new URL(post.linkUrl);
  } catch {
    errors.push('Please enter a valid URL');
  }
  
  return errors;
};

export const updateBlogPostStats = (posts, postId, type) => {
  return posts.map(post => {
    if (post.id === postId) {
      if (type === 'like') {
        return { ...post, likes: post.likes + 1 };
      } else if (type === 'view') {
        return { ...post, views: post.views + 1 };
      }
    }
    return post;
  });
};

export const saveBlogPostsToFile = (posts) => {
  try {
    const dataStr = JSON.stringify({ posts }, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    
    const link = document.createElement('a');
    link.href = URL.createObjectURL(dataBlob);
    link.download = 'blogPosts_updated.json';
    link.click();
    
    URL.revokeObjectURL(link.href);
    
    // Also save to localStorage for persistence
    localStorage.setItem('blogPosts', dataStr);
    
    return true;
  } catch (error) {
    console.error('Error saving blog posts to file:', error);
    return false;
  }
};

export const saveBlogPostsToStorage = (posts) => {
  try {
    const dataStr = JSON.stringify({ posts }, null, 2);
    localStorage.setItem('blogPosts', dataStr);
    return true;
  } catch (error) {
    console.error('Error saving blog posts to storage:', error);
    return false;
  }
};

export const loadBlogPostsFromStorage = () => {
  try {
    const storedPosts = localStorage.getItem('blogPosts');
    if (storedPosts) {
      return JSON.parse(storedPosts).posts;
    }
    return null;
  } catch (error) {
    console.error('Error loading blog posts from storage:', error);
    return null;
  }
};

export const saveLikesToJSON = async (posts, postId) => {
  try {
    // Update the posts array with the new like count
    const updatedPosts = posts.map(post => {
      if (post.id === postId) {
        return { ...post, likes: post.likes + 1 };
      }
      return post;
    });

    // Save to localStorage only
    const jsonData = JSON.stringify({ posts: updatedPosts }, null, 2);
    localStorage.setItem('blogPosts', jsonData);
    
    return updatedPosts;
  } catch (error) {
    console.error('Error saving likes to JSON:', error);
    return posts;
  }
};

export const downloadBlogPostsFile = (posts) => {
  try {
    // Create the JSON data
    const jsonData = JSON.stringify({ posts }, null, 2);
    
    // Create downloadable file
    const dataBlob = new Blob([jsonData], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    
    // Create a temporary link to download the file
    const link = document.createElement('a');
    link.href = url;
    link.download = 'blogPosts_updated.json';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Clean up the URL
    URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error('Error downloading blog posts file:', error);
    return false;
  }
};

export const loadLikesFromLocalStorage = () => {
  try {
    const likedPosts = localStorage.getItem('likedPosts');
    return likedPosts ? new Set(JSON.parse(likedPosts)) : new Set();
  } catch (error) {
    console.error('Error loading likes from localStorage:', error);
    return new Set();
  }
};

export const saveLikesToLocalStorage = (likedPosts) => {
  try {
    localStorage.setItem('likedPosts', JSON.stringify([...likedPosts]));
  } catch (error) {
    console.error('Error saving likes to localStorage:', error);
  }
};

export const formatNumber = (num) => {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
}; 